import {ObvioEvent} from 'Event'
import {Client} from 'lib/ui/api-client'
import {api} from 'lib/url'
import {useQuery} from 'react-query'

export type ObieJourney = {
  id: string
  name: string
}

export function useObieJourneys(params: {
  client: Client
  event: ObvioEvent
  obieHubId: string
}) {
  const {client, event, obieHubId} = params

  return useQuery<ObieJourney[], {message: string; status?: number}>({
    queryKey: [
      'events',
      event.id,
      'integrations',
      'obie',
      'journeys',
      obieHubId,
    ],
    queryFn: () =>
      client.get<ObieJourney[]>(
        api(
          `/events/${event.id}/integrations/obie/journeys?obie_hub_id=${obieHubId}`,
        ),
      ),
    retry: (failureCount, error) => error.status !== 404 && failureCount < 3,
  })
}
